import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/dbSelector';
import {
    OBJECT_TYPE_GENERAL_ADMISSION,
    OBJECT_TYPE_SEAT,
} from '%paysera_seat_selection/js/seatSelection/config/constants';

export default createSelector(
    orm,
    dbSelector,
    (state, hash, type) => ({ hash, type }),
    ({ Seat, GeneralAdmission }, { hash, type }) => {
        if (type === OBJECT_TYPE_SEAT) {
            return Seat.get({ hash });
        }
        if (type === OBJECT_TYPE_GENERAL_ADMISSION) {
            return GeneralAdmission.get({ hash });
        }

        return null;
    },
);
